export default "<div class=\"eand-main-loader\"></div>";